import { AlertTriangle } from 'lucide-react';

export default function PotentialRoadblocks() {
  const roadblocks = [
    {
      title: "Visa Overstay",
      description: "Most applicants must maintain a valid immigration status. However, immediate relatives of U.S. citizens can often adjust status even if they overstayed their visa."
    },
    {
      title: "Public Charge",
      description: "Problems arise when a financial sponsor's income is too low. Supporting documents are not sufficient, or a joint sponsor is required."
    },
    {
      title: "Unauthorized Travel",
      description: "Problems arise when applicants leave the U.S. without authorization or by causing USCIS to treat the adjustment application as abandoned and risking denial."
    },
    {
      title: "Changes in Circumstances",
      description: "You'll need to stay eligible the whole way through. Life events, such as changes in marital situation or finances, can create problems and even put your adjustment at risk."
    }
  ];

  return (
    <section className="py-12 px-4 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-teal-700 mb-2">
            Potential Roadblocks
          </h2>
          <p className="text-lg text-gray-700">
            Where do other people run into problems?
          </p>
        </div>

        {/* Intro text */}
        <p className="text-gray-700 mb-8 leading-relaxed">
          Even if you initially meet the requirements, there are several issues that can delay or prevent your green card approval.
        </p>

        {/* Roadblock cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {roadblocks.map((roadblock, index) => (
            <div key={index} className="bg-white border-2 border-teal-500 rounded-lg p-6 flex flex-col items-center text-center">
              {/* Warning icon */}
              <div className="mb-4">
                <AlertTriangle className="w-12 h-12 text-yellow-500" fill="currentColor" />
              </div>
              
              {/* Title */}
              <h3 className="font-bold text-teal-700 mb-3 text-lg">
                {roadblock.title}
              </h3>
              
              {/* Description */}
              <p className="text-gray-700 text-sm mb-6 flex-grow leading-relaxed">
                {roadblock.description}
              </p>
              
              {/* Button */}
              <button className="border-2 border-yellow-500 text-yellow-600 hover:bg-yellow-50 px-6 py-2 rounded transition font-semibold text-sm">
                LEARN MORE
              </button>
            </div>
          ))}
        </div>

        {/* Footer text */}
        <p className="text-gray-700 leading-relaxed text-center">
          Our goal is to help you avoid RFEs (Requests for Evidence), ensure approval, and get the best processing times with thorough documentation of your eligibility.
        </p>
      </div>
    </section>
  );
}